import { createTheme } from "@mui/material/styles";

const font = "'Roboto', 'Helvetica', 'Arial', sans-serif";

const myProps = {
  shape: { borderRadius: 24 },
};

const myComponents = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 20,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 20,
      },
    },
  },
  MuiCard: {
    defaultProps: {
      elevation: 0,
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 24,
      },
    },
  },
  typography: {
    fontFamily: font,
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2962ff", //D50000 //1b73e8
    },
    secondary: { main: "#2962ff" },
    background: {
      paper: "#fff",
      default: "#f2f6fc", //"#f8f9fa",
    },
    text: {
      primary: "#37474f", //'#202124',
      secondary: "#455a64",
    },
  },
  components: {
    ...myComponents,
  },
  ...myProps,
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#2979ff" }, //D50000 //1b73e8
    secondary: { main: "#448aff" }, //valuestyle
    background: {
      paper: "#28292c", //"#303134", //"#202020",
      default: "#18191c", //"#202124", //"#181818",
    },
    text: {
      primary: "#cfd8dc", //'rgba(255 255 255/0.76)', bdc1c6
      secondary: "#b0bec5",
    },
  },
  ...myProps,
  components: {
    ...myComponents,
    MuiButton: {
      styleOverrides: {
        text: {
          color: "#448aff",
        },
        root: {
          //repeated because the color override cancels it.
          borderRadius: 20,
        },
      },
    },
  },
});

// Create a theme instance.
